/* Montela Mix & Match — cart progress (cart page + Kaching cart drawer) and card labels.
   Counts shoe pairs in the cart (accessories and free gifts excluded) and shows
   how far the customer is from 15 % (2 pairs) and 25 % (3+ pairs). */
(function () {
  var C = window.MM;
  if (!C || !C.t) return;

  var last = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function isShoe(item) {
    if (!item || !item.price) return false;
    var type = (item.product_type || '').toLowerCase();
    if (C.exTypes.indexOf(type) > -1) return false;
    var handle = (item.handle || '').toLowerCase();
    for (var i = 0; i < C.exKeys.length; i++) {
      if (handle.indexOf(C.exKeys[i]) > -1) return false;
    }
    return true;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(C.locale, {
        style: 'currency',
        currency: C.currency,
        currencyDisplay: C.currency === 'EUR' ? 'symbol' : 'code', /* Montela: EUR plain, other currencies with ISO code */
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function build(pairs, subtotal, total) {
    var out = '';
    if (pairs >= 1) {
      var msg = pairs === 1 ? C.t.c1 : pairs === 2 ? C.t.c2 : C.t.c3;
      var pct = pairs >= 3 ? 25 : pairs === 2 ? 15 : 0;
      var fill = pairs >= 3 ? 100 : pairs === 2 ? 66 : 33;
      var save = pct ? Math.round(subtotal * pct / 100) : 0;
      out += '<div class="mm-prog__msg">' + msg + '</div>' +
        '<div class="mm-prog__track"><div class="mm-prog__fill" style="width:' + fill + '%"></div></div>' +
        '<div class="mm-prog__steps">' +
          '<span class="' + (pairs >= 1 ? 'on' : '') + '">' + C.t.p1 + '</span>' +
          '<span class="' + (pairs >= 2 ? 'on' : '') + '">' + C.t.p2 + ' −15%</span>' +
          '<span class="' + (pairs >= 3 ? 'on' : '') + '">' + C.t.p3 + ' −25%</span>' +
        '</div>' +
        (save ? '<div class="mm-prog__save">' + C.t.save + ' <strong>' + money(save) + '</strong></div>' : '');
    }
    if (total > 0 && C.ship > 0) {
      var left = C.ship - total;
      out += '<div class="mm-prog__ship' + (left <= 0 ? ' is-ok' : '') + '">' +
        (left > 0 ? C.t.ship_left.replace('[x]', '<strong>' + money(left) + '</strong>') : C.t.ship_ok) + '</div>';
    }
    return out;
  }

  function current() {
    if (!last) return '';
    var pairs = 0, subtotal = 0;
    (last.items || []).forEach(function (item) {
      if (isShoe(item)) {
        pairs += item.quantity;
        subtotal += item.original_line_price || item.line_price || 0;
      }
    });
    return build(pairs, subtotal, last.total_price || 0);
  }

  function paintDrawer(html) {
    var drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;
    var box = drawer.querySelector('.mm-prog--drawer');
    if (!html) { if (box) box.remove(); return; }
    var header = drawer.querySelector('.kaching-cart__header');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mm-prog mm-prog--drawer';
      if (header) header.insertAdjacentElement('afterend', box);
      else drawer.insertBefore(box, drawer.firstChild);
    } else if (header && box.previousElementSibling !== header) {
      header.insertAdjacentElement('afterend', box);
    }
    if (box.innerHTML !== html) box.innerHTML = html;
  }


  // Cart page: progress box under the title
  function ensureCartPageBox() {
    if (document.querySelector('[data-mm-progress]')) return;
    var wrap = document.querySelector('cart-items .title-wrapper-with-link');
    if (!wrap) return;
    var box = document.createElement('div');
    box.className = 'mm-prog';
    box.setAttribute('data-mm-progress', '');
    box.style.display = 'none';
    wrap.insertAdjacentElement('afterend', box);
  }

  // Collection pages: Mix & Match banner above the product grid
  function placeCollBanner() {
    var tpl = document.getElementById('mm-coll-tpl');
    if (!tpl || document.querySelector('.mm-coll')) return;
    var grid = document.querySelector('[class*="montela-collection-grid__container"], #ProductGridContainer, .product-grid-container');
    if (!grid) return;
    grid.parentNode.insertBefore(tpl.content.cloneNode(true), grid);
  }

  // Product cards: "Mix & Match" label under the price (shoes only).
  // Works for the Dawn cards (.card-wrapper) and the Montela collection grid (li[data-product-card]).
  function labelCards() {
    if (!C.t.card) return;
    document.querySelectorAll('.card-wrapper, [data-product-card]').forEach(function (card) {
      if (card.querySelector('.mm-card')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var anchor = card.querySelector('[class*="price-wrapper"]') || card.querySelector('.price');
      if (!link || !anchor) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]).toLowerCase();
      for (var i = 0; i < C.exKeys.length; i++) { if (handle.indexOf(C.exKeys[i]) > -1) return; }
      var tag = document.createElement('span');
      tag.className = 'mm-card';
      tag.innerHTML = C.t.card;
      anchor.insertAdjacentElement('afterend', tag);
    });
  }

  function paint() {
    var html = current();
    document.querySelectorAll('[data-mm-progress]').forEach(function (el) {
      el.innerHTML = html;
      el.style.display = html ? '' : 'none';
    });
    paintDrawer(html);
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { last = cart; paint(); })
        .catch(function () {});
    }, 200);
  }

  var CART_RE = /\/cart\/(add|change|update|clear)/;

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (CART_RE.test(url)) p.then(refresh, refresh);
      return p;
    };
  }

  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(url || '')) this.addEventListener('loadend', refresh);
    return open.apply(this, arguments);
  };

  // Kaching re-renders its drawer; put the progress bar back when that happens.
  var busy = false;
  var mo = new MutationObserver(function () {
    if (busy) return;
    busy = true;
    requestAnimationFrame(function () {
      var drawer = document.querySelector('kaching-cart-drawer');
      var html = current();
      if (drawer && html && !drawer.querySelector('.mm-prog--drawer')) paintDrawer(html);
      placeCollBanner();
      labelCards();
      busy = false;
    });
  });

  function start() {
    placeCollBanner();
    ensureCartPageBox();
    labelCards();
    refresh();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* mm-cart-pulse guard: Kaching Cart updates only the number inside the header bubble (e.g. to "0")
   instead of removing it. Mark a zero/empty bubble so mm.css hides it (no bubble, no pulse when empty). */
;(function () {
  function mark() {
    var bs = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');
    for (var i = 0; i < bs.length; i++) {
      var s = bs[i].querySelector('span[aria-hidden="true"]');
      var n = parseInt(((s || bs[i]).textContent || '').trim(), 10);
      var zero = !(n > 0);
      if (bs[i].hasAttribute('data-mm-zero') !== zero) bs[i].toggleAttribute('data-mm-zero', zero);
    }
  }
  function start() {
    var icon = document.getElementById('cart-icon-bubble');
    var root = (icon && (icon.closest('header') || icon.parentElement)) || document.body;
    mark();
    new MutationObserver(mark).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
